import styled from 'styled-components';

import {
  LIGHT_GRAY,
  GRAY,
  BLACK,
} from '../../theme';
import Select from '../../oldpantheon/components/Select';
import PendingInput from '../../oldpantheon/components/PendingInput';

const SMALL_DESKTOP = `48rem`;

export const EmailInput = styled(PendingInput)`
  background-color: ${LIGHT_GRAY};
  width: ${(props) => props.stacked ? `100%` : `50%`};
  margin-right: 1rem;
  color: ${BLACK};
  padding: 0 1rem;
  height: 3.125rem;
  border: 2px solid ${GRAY};
  border-radius: 1.5rem;
  border-color: ${(props) => !props.validationState && `red`};
  margin-bottom: .5rem;
  margin-top: .5rem;

  @media only screen and (max-width: ${SMALL_DESKTOP}) {
    width: 100%;
  }
`;

export const SignSelect = styled(Select)`
  background-color: ${LIGHT_GRAY};
  border: 2px solid ${GRAY};
  border-radius: 1.5rem;

  color: ${BLACK};
  font-size: 1rem;
  padding: 0 1rem;
  margin-bottom: .5rem;
  margin-top: .5rem;

  width: ${(props) => props.stacked ? `100%` : `calc(50% - 2rem)`};
  height:3.125rem;
  line-height:3.125rem;

  @media only screen and (max-width: ${SMALL_DESKTOP}) {
    width: 100%;
  }
`;

export const HelpBlock = styled.p`
  color: ${(props) => props.validationState ? `green` : `red`};
  margin: 0 0 1rem 0;
  text-align: center;
`;

export const LegalText = styled.p`
  margin-top: 1.25rem;
  text-align: center;
  color: ${BLACK};
  font-size: .75rem;

  Link {
    color: ${BLACK};
  }
`;

export const SignUpButtonWrapper = styled.div`
  margin: 0 auto;
  display: block;
`;

export const EnvelopeImage = styled.img`
  width: 9.375rem;
  margin: 0 auto;
  display: block;
`;

export const SignUpSubheader = styled.h3`
  font-weight: lighter;
  text-align: center;
  font-size: 1.375rem;
  margin: 0rem auto .5rem auto;
  color: ${BLACK};
  max-width: 31.25rem;
  line-height: 1.75rem;
`;

export const SubheaderEmphasis = styled.span`
  font-weight: 700;
  font-family: "Calistoga";
`;


export const ConfirmationText = styled.div`
  max-width: 30rem;
  text-align: center;
  margin: 0 auto 1rem auto;
  display: block;
  font-size: 1.125rem;
  font-family: "PT Serif";
  color: ${BLACK};
  line-height: 1.75rem;
`;

export const ConfirmationSubtext = styled.div`
  color: ${BLACK};
  text-align: center;
  max-width: 35.9rem;
  margin: 1rem auto 0 auto;
`;

export const CheckInboxHeader = styled.div`
  font-size: 1.7rem;
  font-family: "Calistoga";
  color: ${BLACK};
  text-align: center;
`;

export const TypeformContainer = styled.div`
  position: relative;
  min-height: 45rem;

  iframe {
    min-height: 45rem;
  }
`;
